/*
 * Misst, wie hoch die unten fixierten Fremd-Overlays gerade bauen, und legt
 * das Ergebnis als `--mv-banner-hoehe` auf <html> ab. Alles, was unten am
 * Bildschirmrand klebt (Warenkorb-Drawer-Footer), kann so ausweichen.
 *
 * Anlass: Der Cookie-Banner der App "Nova: GDPR Cookie Consent" (.cc-window)
 * ist unten fixiert und laeuft mit z-index 9999 — er liegt also ueber dem
 * Warenkorb-Drawer (z-index 1000) und begraebt bei 390x844 den Checkout-Button.
 * Ihn wegzudruecken oder zu ueberdecken ist keine Option: er muss bedienbar
 * bleiben, bevor eingewilligt wurde.
 *
 * Die Kaufleiste auf Produktseiten macht dasselbe fuer sich selbst
 * (movasana-sticky-cart.js) — die laeuft aber nur auf Produktseiten,
 * der Drawer ueberall.
 */
(() => {
  const HINDERNISSE = '.cc-window, #satcb_bar, #pop-convert-app';

  /* ACHTUNG: `offsetParent !== null` ist als Sichtbarkeitspruefung hier FALSCH.
     Bei position: fixed liefert offsetParent IMMER null. */
  const sichtbar = (el) => {
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    return el.getBoundingClientRect().height > 0;
  };

  const anpassen = () => {
    let hoechstes = 0;
    document.querySelectorAll(HINDERNISSE).forEach((el) => {
      if (!sichtbar(el)) return;
      const r = el.getBoundingClientRect();
      // Nur was wirklich unten klebt, nicht irgendein Element weiter oben.
      if (r.bottom < window.innerHeight - 8) return;
      hoechstes = Math.max(hoechstes, Math.round(r.height));
    });
    document.documentElement.style.setProperty('--mv-banner-hoehe', `${hoechstes ? hoechstes + 8 : 0}px`);
    // Reine Anwesenheitsmarke — CSS kann Variablenwerte nicht vergleichen.
    document.documentElement.toggleAttribute('data-mv-banner', hoechstes > 0);
  };

  anpassen();

  // Die Banner werden per JS eingehaengt und wieder entfernt.
  new MutationObserver(anpassen).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
  window.addEventListener('resize', anpassen, { passive: true });

  // Sie erscheinen oft erst kurz nach dem Laden.
  setTimeout(anpassen, 800);
  setTimeout(anpassen, 2500);
})();
